<template>
  <div>
    <div></div>
    <b-button
      style="margin-left: 5px"
      @click="openPreAlert"
      size="sm"
      variant="warning"
    >Send Pre-Alert Mail Happy</b-button>

    <!-- Added By Priyanshu SIngh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="pre-alert-modal"
      hide-footer
      title="FCL Export BL Pre Alert"
    >
      <b-row class="mt-2">
        <b-col cols="3">
          <b-button
            v-if="pre_prealert_id != ''"
            @click="sendMANIFESTATION"
            size="sm"
            variant="warning"
            style="margin-left: 5px"
          >SEND MANIFESTATION DETAILS</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2">

        <b-col cols="6">
          <label for="jj">AGENT REFERENCE ID</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.agent_reference_id"
            placeholder="VESSEL & VOY"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">SHIPPING LINE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shippingLine"
            placeholder="SHIPPING LINE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">SHIPMENT TYPE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shipmentType"
            placeholder="SHIPMENT TYPE"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">CONSIGNOR</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shipper_name"
            placeholder="CONSIGNOR"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">LOAD PORT</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.portLoad"
            placeholder="LOAD PORT"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">PLACE OF DELIVERY</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.placeDilievery"
            placeholder="PLACE OF DELIVERY"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">CONTAINER NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.container_no"
            placeholder="CONTAINER NO."
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">HOUSE BL NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.house_bl_no"
            placeholder="HOUSE BL NO."
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">MASTER BL NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.master_bl_no"
            placeholder="MASTER BL NO."
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">VESSEL & VOY</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.vesselVoy"
            placeholder="VESSEL & VOY"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">ETD / SOB DATE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.etd_date"
            placeholder="ETD / SOB DATE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">ETA DISCHARGE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.eta_date"
            placeholder="ETA DISCHARGE"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <label for="jj">CONSIGNEE</label>
          <b-form-textarea :formatter="capitalizeAll" v-model="preAlertData.consignee"></b-form-textarea>
        </b-col>
        <b-col cols="6">
          <label for="jj">OVERSEAS AGENT</label>
          <b-form-textarea :formatter="capitalizeAll" v-model="preAlertData.delieveryAgent"></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="my-4">
        <b-col cols="6">
          <md-input-container>
            <label>Upload Master BL</label>
            <md-file
              placeholder="Click to Upload Master BL DRAFT"
              name="masterUpload"
              id="masterUpload"
              v-model="preAlertData.masterBlUpload"
              @selected="onFileChangeBlDraft('masterBl')"
              multiple
            ></md-file>
            <br />
          </md-input-container>
          <b
            v-if="preAlertData.masterBlUpload!=''&&preAlertData.masterBlUpload!=undefined&&preAlertData.masterBlUpload!=null"
          >
            <span
              v-for="(item_MB_doc, index_MB_doc) in preAlertData.masterBlUpload.split(',')"
              :key="index_MB_doc"
            >
              <a
                v-if="item_MB_doc !=''"
                href="javascript:void(0)"
                @click="Print(item_MB_doc)"
              >View Document - {{ index_MB_doc + 1 }}</a>
              <br />
            </span>
          </b>
        </b-col>
        <b-col cols="6">
          <md-input-container>
            <label>Upload House BL</label>
            <md-file
              placeholder="Click to Upload House BL DRAFT"
              name="houseUpload"
              id="houseUpload"
              v-model="preAlertData.houseBlUpload"
              @selected="onFileChangeBlDraft('houseBl')"
              multiple
            ></md-file>
          </md-input-container>
          <b
            v-if="preAlertData.houseBlUpload!=''&&preAlertData.houseBlUpload!=undefined&&preAlertData.houseBlUpload!=null"
          >
            <span
              v-for="(item_HB_doc, index_HB_doc) in preAlertData.houseBlUpload.split(',')"
              :key="index_HB_doc"
            >
              <a
                v-if="item_HB_doc !=''"
                href="javascript:void(0)"
                @click="Print(item_HB_doc)"
              >View Document - {{ index_HB_doc+ 1 }}</a>
              <br />
            </span>
          </b>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-button
          variant="success"
          :disabled="(preAlertData.condition)"
          @click="submitPreAlert"
        >Send request</b-button>
        <!-- {{preAlertData.condition}} -->
        <b-button class="ml-2" variant="outline-danger" @click="hidePreAlert">Close</b-button>
      </b-row>
    </b-modal>
     <!-- :disabled="(preAlertData.masterBlUpload_btn || preAlertData.houseBlUpload_btn)?false:true" -->
    <!-- Pre-Alert Modal End -->
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="openPreAlert"
      ref="popBlStageMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendPreAlertMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";
import CommonService from "../../services/CommonService.js";

export default {
  props: [
    "pre_ffExportFclId",
    "pre_allModuleId",
    "pre_title",
    "pre_moduleType",
    "pre_fclBlId",
    "pre_blDate",
    "pre_item",
    "pre_allData",
    "pre_prealertDetails",
    "pre_prealert_id",
    "pre_ffType"
  ],
  beforeMount() {
    if (this.pre_allModuleId != "") {
      // this.getPrealertDetails()
    }
    //  &&
    //   this.Filter_Flag == true &&
    //   this.moduleType &&
    //   this.pre_ffExportFclId
  },

  data() {
    return {
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      prealertDetails: [],
      preAlertData: {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        vesselVoy: "",
        agent_reference_id: "",
        portLoad: "",
        placeDilievery: "",
        consignee: "",
        delieveryAgent: "",
        shipmentType: "fcl",
        etd_date: "",
        eta_date: "",
        house_bl_no: "",
        master_bl_no: "",
        container_no: "",
        shippingLine: "",
        shipper_name: "",
        masterBlUpload: "",
        houseBlUpload: "",
        masterBlUpload_btn: "",
        houseBlUpload_btn: "",
        masterBlUpload_flag: false,
        houseBlUpload_flag: false,
        condition:true,
      },

      allAssignmentSummaryData: [],
      all_module_id: this.cr_all_module_id,
      title: this.title,
      moduleType: this.moduleType,
      ass_date: this.cr_ass_date,
      jb_series: this.cr_jb_series,
      transportType: this.transportType,
      Jobtype: this.Jobtype,
      commonId: this.commonId,
      shipmentType: this.shipmentType,
      Filter_Flag: false,
      TotAMT: 0,
      ManifestationParticulars: [],
      IsCDNotedisabled: false,
      NoteData: "",
      errorCDNote: {
        AgentColoader: "",
        vesselVoy: "",
        // agent_reference_id: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: ""
      },
      arrayErrorCDNote: [
        {
          AgentColoader: "Please Select To",
          vesselVoy: "Please Enter Vessel/Voy ",
          house_bl_no: "Please Enter HBL/AWB",
          master_bl_no: "Please Enter MBL/MAWB",
          clientName: "Please ENter SHIPPER",
          consignee: "Please Enter SHIPPER",
          FPOD: "Please Enter SHIPPER",
          containerNoArryNote: "Please Enter Container No.",
          containersTypes: "Please Enter Container Type",
          ShipperInvDet: "Please Enter SHIPPER INV"
        }
      ],
      selectDateFormat,
      allModuleId: "",
      ShowSendApproval: "",
      AgentColoaderList: [],
      noteParticulars: [],
      CurrencyList: [],
      containerTypeDetailFactory: [],
      note_id: "",
      getCLientData: ["gfdg"],
      noteModal: {
        shipper: "",
        branchName: "",
        branchList: [],
        AgentColoader: "",
        creditDebitNoteType: "",
        remarks: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        noteCurrency: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: "",
        type: ""
      },
      docURL: URL_BASE_DOC,
      validate: false
      //Added By Priyanshu SIngh End
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function(newVal, oldVal) {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    sendMANIFESTATION() {
      if (this.pre_ffType == "FF Export") {
        this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
        this.$sessionsStorage.set("sendManifest_ffType", "");
        this.$forceUpdate();
        this.$sessionsStorage.set("sendManifest_ffType", "FF Export");
        this.$sessionsStorage.set(
          "sendManifest_ffFclallModuleId",
          this.pre_allModuleId
        );
        this.$sessionsStorage.set(
          "sendManifest_ffExportFclId",
          this.pre_ffExportFclId
        );
        this.$router.push({
          path: "/freightForwarding/sendManifestation"
        });
      }
    },
    onFileChangeBlDraft(ID) {
      this.preAlertData.condition =true;
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      console.log(files);
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "masterBl") {
          this.preAlertData.masterBlUpload_flag  = true;
          formData.append(
            "staticFileName",
            "Sea_Export_MasterBL_" + this.pre_allModuleId
          );
        } else if (ID == "houseBl") {
          this.preAlertData.houseBlUpload_flag = true;
          formData.append(
            "staticFileName",
            "Sea_Export_HouseBL_" + this.pre_allModuleId
          );
        }

        formData.append(
          "upload_dir_folderName",
          // "FF_Sea_Export_Sline_Payments_Uploads"
          this.pre_allData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }

      console.log("Upload => ", formData);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + this.pre_ffExportFclId
        }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then(result => {
          const { data, status, statusText } = result;

          console.log("result=>", result);
          if (ID == "masterBl") {
            this.preAlertData.masterBlUpload = result.data;
            this.preAlertData.masterBlUpload_btn = result.data;
          } else {
            this.preAlertData.houseBlUpload = result.data;
            this.preAlertData.houseBlUpload_btn = result.data;
            // this.preAlertData.houseBlUpload_btn = this.preAlertData.houseBlUpload_flag?result.data:'';
          }
          // this.preAlertData.condition =(this.preAlertData.masterBlUpload_flag && this.preAlertData.houseBlUpload_flag)?((this.preAlertData.masterBlUpload_btn && preAlertData.houseBlUpload_btn)?false:(this.preAlertData.masterBlUpload_btn || this.preAlertData.houseBlUpload_btn)?false:true):true;

          this.preAlertData.condition =(this.preAlertData.masterBlUpload_flag && this.preAlertData.houseBlUpload_flag)?((this.preAlertData.masterBlUpload_btn && this.preAlertData.houseBlUpload_btn)?false:true):false;
          // console.log("this.preAlertData.condition=>",this.preAlertData.condition)
          // console.log("this.preAlertData.masterBlUpload_flag=>",this.preAlertData.masterBlUpload_flag)
          // console.log("this.preAlertData.houseBlUpload_flag=>",this.preAlertData.houseBlUpload_flag)
          // console.log("this.preAlertData.masterBlUpload_flag && this.preAlertData.houseBlUpload_flag=>",this.preAlertData.masterBlUpload_flag && this.preAlertData.houseBlUpload_flag)
          // console.log("this.preAlertData.masterBlUpload_btn && this.preAlertData.houseBlUpload_btn)=>",(this.preAlertData.masterBlUpload_btn &&  this.preAlertData.houseBlUpload_btn))

          // alert(this.preAlertData.masterBlUpload)
          this.isLoading = false;
        })
        .catch(err => {
          throw err;
        });
    },
    openPreAlert() {
      this.isLoading = true;

      // let data = await this.getPrealertDetails();
      // if(this.pre_allModuleId != ""){
      //   this.getPrealertDetails();
      // }
      console.log("prealertDetails=>", this.pre_prealertDetails);
      if (this.pre_prealertDetails) {
        this.preAlertData.masterBlUpload = this.pre_prealertDetails.masterBlUpload;
        this.preAlertData.houseBlUpload = this.pre_prealertDetails.houseBlUpload;
      }
      console.log("prealertDetails=>", this.pre_prealertDetails);
      console.log("pre_item=>", this.pre_item);

      let containerNoArryNote = [];
      this.containerTypeDetailFactory.map(x => {
        containerNoArryNote.push(x.containerNo);
      });

      this.preAlertData["container_no"] = containerNoArryNote.toString();
      this.preAlertData["allModuleId"] = this.pre_allData[0].allModuleId;
      this.preAlertData["shippingId"] = this.pre_allData[0].shippingId;
      this.preAlertData["shippingLine"] = this.pre_allData[0].shippingLine;
      this.preAlertData["delieveryAgent"] = this.pre_item.agentName;
      this.preAlertData["agentEmail"] = this.pre_item.agentEmail;

      this.preAlertData["agentAddress"] = this.pre_item.agentAddress;
      this.preAlertData["vesselVoy"] = this.pre_item.vesselVoy;
      this.preAlertData["agent_reference_id"] = this.pre_item.agent_reference_id;
      //  this.preAlertData["shipper_name"] = this.pre_allData[0].clientName;
      this.preAlertData["shipper_name"] = this.removeTags(
        this.pre_item.consignor
      );
      this.preAlertData["consignee"] = this.removeTags(this.pre_item.consignee);
      this.preAlertData["fclBlId"] = this.pre_item.fclBlId;
      this.preAlertData["branchName"] = this.pre_item.branchName;
      this.preAlertData["placeDilievery"] = this.pre_item.placeDilievery;
      this.preAlertData["portLoad"] = this.pre_item.portLoad;
      this.preAlertData["assignmentNo"] = this.pre_allData[0].ffExportFclSeries;
      this.preAlertData[
        "ffExportFclSeries"
      ] = this.pre_allData[0].ffExportFclSeries.replaceAll("/", "_");

      this.preAlertData["mailPreAlert"] = "1";

      this.preAlertData["master_bl_no"] = this.pre_allData[0].linerBLNumber;
      this.preAlertData["house_bl_no"] =
        this.pre_item.billLading +
        (this.fclConId != "" ? this.fclConId : this.pre_item.fclBlId);

      if (this.trackingId != "") {
        let payload = {
          subscriptionId: this.trackingId
        };

        // console.log(this.$sessionsStorage.get("loginId"))

        console.log("Test => ", payload);
        console.log("BLRaised => ", this.pre_item);
        console.log("allData => ", this.pre_allData);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            this.isLoading = false;
            const { statusText, status, data } = result;

            // alert(statusText+" : "+status+" : "+data)
            if (status == 200 && data) {
              //alert(data);

              console.log("Result => ", JSON.parse(data.data));

              data.data = JSON.parse(data.data);

              // this.shippmentDetails.push(data.data);

              if (data.data.containershipments.length > 0) {
                this.preAlertData["vesselVoy"] = data.data
                  .containershipments[0]["current_vessel"]
                  ? data.data.containershipments[0]["current_vessel"]["name"]
                  : "";
                this.preAlertData["etd_date"] =
                  data.data.containershipments[0]["pol_vsldeparture_actual"] ||
                  data.data.containershipments[0][
                    "pol_vsldeparture_planned_last"
                  ];
                this.preAlertData["eta_date"] =
                  data.data.containershipments[0]["pod_vslarrival_actual"] ||
                  data.data.containershipments[0][
                    "pod_vslarrival_planned_last"
                  ];
              }
            }
          })
          .catch(error => {
            this.isLoading = false;
            console.log("Err => ", error);
          });
      }

      this.isLoading = false;

      this.$refs["pre-alert-modal"].show();
    },
    getPrealertDetails() {
      let payload = {
        allModuleId: this.pre_allModuleId,
        itemCode: "GET_PreAlert_Data",
        itemtype: "FCL"
      };
      payload = JSON.stringify(payload);
      CommonService.getAllPreAlertDetails(payload)
        .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("Data Found", data.PreAlert_Data.length);
            if (data.PreAlert_Data.length > 0) {
              this.prealertDetails = data.PreAlert_Data;
            }
          } else {
            console.log("Data Not Found");
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.log("Catch on getAllPreAlertDetails Error: ", error);
        });
    },
    hidePreAlert() {
      this.$refs["pre-alert-modal"].hide();
      if (this.savegenerateblprealertStatus == true) {
        this.openPopensureprealert();
      }
    },
    openPopMail() {
      this.alert.content = "Send Pre-Alert ..?";
      this.$refs["popMail"].open();
    },
    sendPreAlertMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let containerNoArry = [];
        this.containerTypeDetailFactory.map(x => {
          containerNoArry.push(x.containerNo);
        });

        let newData = {
          mailPreAlert: "PreAlrt",
          clientName: this.pre_allData[0].clientName,
          shippingLine: this.pre_allData[0].shippingLine,
          overseasClient: this.pre_allData[0].overseasClient,
          assignmentNo: this.pre_allData[0].ffExportFclSeries,
          shipmentType: this.pre_allData[0].containerInfo,
          FinalPlace: this.pre_item.placeDilievery,
          consignee: this.pre_item.consignee,
          vesselVoy: this.pre_item.vesselVoy,
          agent_reference_id: this.pre_item.agent_reference_id,
          containerNoArry: containerNoArry
        };

        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/sendPreAlertMailBL.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.savegenerateblprealertStatus = false;
              this.isLoading = false;
            })
            .catch(error => {});
        }
      }
    },
    Print(item) {
      const d = new Date().getTime();
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/` +
          this.pre_allData[0].ffExportFclSeries.replaceAll("/", "_") +
          "/" +
          item +
          "?token=" +
          d
      );
    },
    submitPreAlert() {
      this.isLoading = true;
      this.$refs["pre-alert-modal"].hide();
      let options = {
        method: "POST",
        url: `${URL_BASE}/sendPreAlertMailFclBL.php`,
        data: JSON.stringify(this.preAlertData),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          this.isLoading = false;
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Inserted Successfully") {
              this.alert.content = "Request has been sent";
            } else {
              this.alert.content = "Request has been sent";
            }
            this.savegenerateblprealertStatus = false;

            this.$refs["pre-alert-modal"].hide();
            this.$refs["addPop"].open();
          }
        })
        .catch(error => {
          this.isLoading = false;
        });

      //  this.isLoading=false
    },

    sendCommonManifestation(item) {
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffExportFclId", "");
      this.$sessionsStorage.set("sendManifest_shipmentType", "");
      this.$sessionsStorage.set("sendManifest_moduleType", "");
      this.$sessionsStorage.set("sendManifest_JobSeries", "");
      this.$sessionsStorage.set("sendManifest_JOBSERIES", "");
      this.$sessionsStorage.set("sendManifest_Transport_Type", "");
      this.$sessionsStorage.set("sendManifest_Jobtype", "");
      this.$sessionsStorage.set(
        "sendManifest_ffFclallModuleId",
        this.cr_all_module_id
      );
      this.$sessionsStorage.set("sendManifest_ffExportFclId", this.commonId);
      this.$sessionsStorage.set("sendManifest_shipmentType", this.shipmentType);
      this.$sessionsStorage.set("sendManifest_moduleType", this.moduleType);
      this.$sessionsStorage.set("sendManifest_JobSeries", this.jb_series);
      this.$sessionsStorage.set("sendManifest_JOBSERIES", this.jb_series);
      this.$sessionsStorage.set(
        "sendManifest_Transport_Type",
        this.transportType
      );
      this.$sessionsStorage.set("sendManifest_Jobtype", this.Jobtype);
      this.$router.push({
        path: "/freightForwarding/CommonManifestation"
      });
    },
    AssignmentSummary() {
      this.Filter_Flag = true;
      this.getAssignmentSummary();
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList"
        })
      );
      this.$store.dispatch("common/setAllAgentColoaderList");
    },
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    validateAddManifestationDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.noteParticulars;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].addManifestation_ledgerId != "") {
          if (MainARR[j].parti == "") {
            this.noteParticulars[j]["parti_err"] = "Please Enter Particular";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.noteParticulars[j]["parti_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].amt == "") {
            this.noteParticulars[j]["amt_err"] = "Please Enter Amount";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.noteParticulars[j]["amt_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].currency == "") {
            this.noteParticulars[j]["currency_err"] = "Please Enter Currency";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.noteParticulars[j]["currency_err"] = "";
            validate_new = true;
          }
        }
      }
      console.log("this.noteParticulars=>", this.noteParticulars);

      if (errCount > 0) {
        this.validate = false;
      }
      if (validate_new == false) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    submitNote() {
      this.validateCDNote();
      if (this.validate == false) return false;
      this.validateAddManifestationDetail();
      if (this.validate == false) return false;

      this.isLoading = true;
      this.ShowSendApproval = false;

      if (this.noteParticulars.length <= 0) {
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];
      let noteCurrency = [];
      this.noteModal["fk_currency_id"] = "";
      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        noteAmt.push(
          this.noteParticulars[i].amt ? this.noteParticulars[i].amt : 0
        );
        noteCurrency.push(
          this.noteParticulars[i].currency
            ? this.noteParticulars[i].currency
            : 0
        );
        this.noteModal["fk_currency_id"] = this.noteParticulars[i].currency
          ? this.noteParticulars[i].currency
          : "1";
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      this.noteModal.noteCurrency = noteCurrency.toString();

      // console.log("NoteData=>",this.NoteData);
      // console.log("noteModal=>",this.noteModal);
      this.noteModal[
        "containerNoArryNote"
      ] = this.noteModal.containerNoArryNote;
      this.noteModal["containerTypesArr"] = this.noteModal.containersTypes;
      this.noteModal["ShipperInvDet"] =
        this.noteModal.ShipperInvDet == undefined
          ? ""
          : this.noteModal.ShipperInvDet;
      this.noteModal["type"] = this.NoteData.over_type;
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.NoteData.allModuleId;
      this.noteModal["agentName"] = this.noteModal.AgentColoader;
      this.noteModal["overseas_agent"] = this.noteModal.AgentColoader;
      this.noteModal["agentAddress"] = this.NoteData.agentAddress;
      this.noteModal["vesselVoy"] = this.noteModal.vesselVoy;
      this.noteModal["agent_reference_id"] = this.noteModal.agent_reference_id;
      this.noteModal["shipper"] =
        this.noteModal.clientName == undefined ? "" : this.noteModal.clientName;
      this.noteModal["consignee"] =
        this.noteModal.consignee == undefined ? "" : this.noteModal.consignee;
      this.noteModal["fclBlId"] = 0;
      this.noteModal["branchName"] = this.NoteData.raisedFrom;
      this.noteModal["FinalPlace"] = this.NoteData.FPOD;
      this.noteModal["master_bl_no"] =
        this.noteModal.master_bl_no == undefined
          ? ""
          : this.noteModal.master_bl_no;
      this.noteModal["house_bl_no"] =
        this.noteModal.house_bl_no == undefined
          ? ""
          : this.noteModal.house_bl_no;
      this.noteModal["masterorLinerBlNo"] =
        this.noteModal.master_bl_no == undefined
          ? ""
          : this.noteModal.master_bl_no;
      this.noteModal["BLNumber"] =
        this.noteModal.house_bl_no == undefined
          ? ""
          : this.noteModal.house_bl_no;
      this.noteModal["page"] = "common";
      this.noteModal["salesSeries"] = this.NoteData.mainSalesSeries;
      this.noteModal[
        "salesSeriesUpload"
      ] = this.NoteData.mainSalesSeries.replaceAll("/", "_");
      // alert(this.NoteData.over_common_id)
      // alert(this.noteModal.commonId)
      this.noteModal["ffExportFclId"] =
        this.NoteData.over_commonId == undefined
          ? this.noteModal.commonId
          : this.NoteData.over_common_id;
      this.noteModal["LPM"] = this.NoteData.POL;
      this.noteModal["PODM"] = this.NoteData.POD;
      this.noteModal["PORM"] = this.NoteData.POR;
      this.noteModal["clientNameM"] = this.NoteData.clientName;
      this.noteModal["shippingLineM"] = this.NoteData.shippingLine;
      this.noteModal["ASeriesM"] = this.NoteData.mainSalesSeries;
      this.noteModal["agentNameM"] = this.noteModal.AgentColoader;
      this.noteModal["overseas_agentM"] = this.noteModal.AgentColoader;
      this.noteModal["ASDateM"] = this.NoteData.assDate;
      this.noteModal["ToM"] = this.noteModal.AgentColoader;
      if (this.noteModal["vesselVoy"] == undefined) {
        this.noteModal["vesselVoy"] = "";
      }

      if (this.noteModal["fclBlId"] == undefined) {
        this.noteModal["fclBlId"] = "0";
      }

      if (this.noteModal["agentAddress"] == undefined) {
        this.noteModal["agentAddress"] = "";
      }

      if (this.noteModal["BLNumber"] == "NaN") {
        this.noteModal["BLNumber"] = "";
      }
      this.IsCDNotedisabled = true;
      console.log("this.NoteData JIO=>", this.NoteData);
      console.log("this.noteModal JIO=>", this.noteModal);
      // return false;
      if (this.validate != false) {
        console.log(this.noteModal);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew_VP.php`,
          data: JSON.stringify(this.noteModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.IsCDNotedisabled = false;

              Object.keys(this.noteModal).map(x => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];
              this.$refs["common-note-modal"].hide();
              this.$refs["addPop"].open();
              // this.getData();
              this.viewFFExportFCL("0", "0", "1", "1");
            }
          })
          .catch(error => {});
      }
    },
    TotalAMT() {
      let TotAmount = 0;
      this.noteParticulars.forEach((value, index) => {
        let amount = 0;
        if (isNaN(value.amt) || value.amt == "") {
          amount = 0;
        } else {
          amount = value.amt;
        }
        if (this.TotAMT == 0) {
          TotAmount = eval(amount);
        } else {
          TotAmount = eval(TotAmount) + eval(amount);
        }
        this.TotAMT = TotAmount;
      });
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    getCurrencyList() {
      return new Promise(resolve => {
        this.CurrencyList = [];
        let payload = {
          Currency: "Currency_DropDown"
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CurrencyList.length > 0) {
                this.CurrencyList = data.CurrencyList;
              } else {
                this.CurrencyList = [];
              }
              return resolve(this.CurrencyList);
            }
          })
          .catch(error => {});
      });
    },
    commonOpenNoteModal(id, item) {
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList"
        })
      );
      this.TotAMT = 0;
      this.noteParticulars = [];
      let noteType = "";
      if (id == "1") {
        noteType = "CREDIT";
      } else if (id == "2") {
        noteType = "DEBIT";
      }
      item.mainManifestationData.forEach(element => {
        if (noteType == element.noteType) {
          let obj = {
            parti: element.ledgerId,
            amt: element.amount,
            currency: element.currency
          };
          this.noteParticulars.push(obj);
        }
      });
      if (this.noteParticulars.length > 0) {
        this.TotalAMT();
      }
      this.NoteData = "";
      this.containerTypeDetailFactory = [];
      this.NoteData = item;
      console.log("Priyanshu SIngh=>", item);
      this.noteModal.containersTypes =
        item.over_shipmentType == "Sea" ? item.containerType : "NA";
      this.noteModal.containerNoArryNote =
        item.over_shipmentType == "Sea" ? item.containerNo : "NA";
      this.noteModal.FPOD =
        item.over_shipmentType == "Sea" ? item.FPOD : item.airDesti;
      this.noteModal.house_bl_no = item.house_bl_no;
      this.noteModal.master_bl_no = item.master_bl_no;
      this.noteModal.vesselVoy = item.vesselVoy;
      this.noteModal.agent_reference_id = item.agent_reference_id;
      this.noteModal.clientName = item.clientName;
      // alert(item.mainManifestationData[0].agent_coloder_txt);
      this.noteModal.AgentColoader = item.agent_coloder_txt;
      this.noteModal.shipper = item.clientName;
      this.noteModal.creditcount = item.creditcount;
      this.noteModal.debitcount = item.debitcount;
      this.noteModal.commonId = item.over_common_id;
      let creditnoteSeriesDetails = [];
      let debitnoteSeriesDetails = [];
      if (item.NoteDetails.length > 0) {
        item.NoteDetails.map(NS => {
          if (NS.creditDebitNoteType == 1)
            creditnoteSeriesDetails.push(NS.noteSeries);
        });
        item.NoteDetails.map(NS => {
          if (NS.creditDebitNoteType == 2)
            debitnoteSeriesDetails.push(NS.noteSeries);
        });
      }
      this.noteModal.creditnoteSeriesDetailsCount = creditnoteSeriesDetails.toString();
      this.noteModal.debitnoteSeriesDetailsCount = debitnoteSeriesDetails.toString();
      console.log("Single Note Details=>", item);
      console.log("this.NoteData=>", this.NoteData);
      // return false;

      this.noteModal.creditDebitNoteType = id;
      this.$refs["common-note-modal"].show();
    },
    hideNoteModal() {
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.noteCurrency = "";
      this.note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.$refs["common-note-modal"].hide();
      this.isLoading = false;
    },

    addContent() {
      let obj = {
        parti: "",
        amt: "",
        currency: "1"
      };
      this.noteParticulars.push(obj);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
      this.TotalAMT();
    },
    validateCDNote() {
      let validate_new = true;
      Object.keys(this.errorCDNote).map((x, index) => {
        if (
          this.noteModal[x] == "" ||
          this.noteModal[x] == undefined ||
          this.noteModal[x] == null
        ) {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/` +
          ffExportFclSeries.replaceAll("/", "_") +
          "/" +
          uploadCreditDebit
      );
    },
    getAssignmentSummary() {
      if (this.Filter_Flag == true) {
        let AssignmentSummary = {
          filter: "CRDRDetails",
          allModuleId: this.cr_all_module_id
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/viewAssignmentTrackDetails.php`,
          data: JSON.stringify(AssignmentSummary),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CreditDebitNoteDetails.length > 0) {
                this.allAssignmentSummaryData = data.CreditDebitNoteDetails;
              }
              // this.isLoading = false;
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>


// WEBPACK FOOTER //
// prealertMail.vue?7eab7440